import {Component, HostListener, OnInit} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {UserAuthenticationService} from "../common/user-authentication.service";
import {Login} from "../login/login";
import {ApplicationError} from "../common/application-error";
import {SESSION_STORAGE_KEYS} from "../common/session-storage-keys";
import {User} from "../common/user";
import {PasswordRegexConstant, Utils} from "../common/utils";
import {ConfirmDialogService} from "../common/confirm-dialog/confirm-dialog.service";
import {ConnectDialog} from "../common/confirm-dialog/connect-dialog";
import {finalize} from "rxjs/internal/operators";

@Component({
    selector: 'dp-my-credentials',
    templateUrl: './my-credentials.component.html'
})
export class MyCredentialsComponent implements OnInit {

    passwordConfirmed: boolean;
    confirmPassFormGroup: FormGroup;
    isCurrentPasswordVisible: boolean;
    isNewPasswordVisible: boolean;
    isRetypePasswordVisible: boolean;

    changeEmailFormGroup: FormGroup;
    changePassFormGroup: FormGroup;

    constructor(private userAuthenticationService: UserAuthenticationService,
                private confirmDialogService: ConfirmDialogService) {
    }

    @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
        e.preventDefault();
    }

    @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
        e.preventDefault();
    }

    @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
        e.preventDefault();
    }

    ngOnInit() {

        this.createConfirmPassFormGroup();
        this.createChangeEmailFormGroup();
        this.createChangePassFormGroup();
    }

    createConfirmPassFormGroup() : void {
        this.confirmPassFormGroup = new FormGroup({
            'currentPassword': new FormControl('', Validators.required)
        });
    }

    createChangeEmailFormGroup() : void {
        this.changeEmailFormGroup = new FormGroup({
            'newEmail': new FormControl('', Validators.compose([Validators.required, Validators.email])),
        });
        this.changeEmailFormGroup.addControl( 'retypeEmail', new FormControl('', Validators.compose([Validators.required, Validators.email,
            Utils.fieldMatchValidator('newEmail', this.changeEmailFormGroup , { mustMatch: true })])));
    }

    createChangePassFormGroup() : void {
        this.changePassFormGroup = new FormGroup({'newPassword': Utils.createChangePassFormControl()});
        this.changePassFormGroup.addControl( 'retypePassword', new FormControl('',
            Validators.compose([Validators.required, Utils.fieldMatchValidator('newPassword', this.changePassFormGroup , { mustMatch: true })])));
    }

    isSubmitPasswordBtnEnabled() : boolean {
        return this.confirmPassFormGroup.controls['currentPassword'].value;
    }

    submitPassword() : void {
        let sessionUser: User = new User(JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEYS.user)));
        let verifyRequest = new Login();
        verifyRequest.loginId = sessionUser.username;
        verifyRequest.password = this.confirmPassFormGroup.controls['currentPassword'].value;

        this.userAuthenticationService.updateLoginParams(verifyRequest).subscribe(
            (res) => {
                this.passwordConfirmed = true;
            },
            (error: ApplicationError) => {

            });
    }

    isSubmitEmailBtnEnabled() : boolean {
        return this.changeEmailFormGroup.controls['newEmail'].value &&
            this.changeEmailFormGroup.controls['retypeEmail'].value &&
            this.changeEmailFormGroup.controls['newEmail'].value == this.changeEmailFormGroup.controls['retypeEmail'].value;
    }

    isChangePasswordBtnEnabled() : boolean {
        return this.changePassFormGroup.controls['newPassword'].value &&
            this.changePassFormGroup.controls['retypePassword'].value &&
            this.changePassFormGroup.controls['newPassword'].value == this.changePassFormGroup.controls['retypePassword'].value;
    }

    updateUserEmail() : void {
        let sessionUser: User = new User(JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEYS.user)));
        sessionUser.loginId = this.changeEmailFormGroup.controls['newEmail'].value;
        sessionUser.username = this.changeEmailFormGroup.controls['newEmail'].value;
        sessionUser.retypeLoginId = this.changeEmailFormGroup.controls['retypeEmail'].value;
        this.userAuthenticationService.updateUserEmail(sessionUser)
            .pipe( finalize(() => this.passwordConfirmed = false))
            .subscribe((res: User) => {
                    //put the new values in the session storage
                    sessionStorage.setItem(SESSION_STORAGE_KEYS.user, JSON.stringify(sessionUser));
                    this.showSuccessMessage('Your Email has been successfully changed.');
                    this.clearFormControls(this.changeEmailFormGroup);
                },
                (error: ApplicationError) => {

                });
    }

    changePassword() : void {
        let sessionUser: User = new User(JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEYS.user)));
        sessionUser.password = this.changePassFormGroup.controls['newPassword'].value;
        sessionUser.retypePassword = this.changePassFormGroup.controls['retypePassword'].value;
        this.userAuthenticationService.updateUserPwd(sessionUser)
            .pipe( finalize(() => this.passwordConfirmed = false))
            .subscribe((res: User) => {
                this.showSuccessMessage('Your Password has been successfully changed.');
                    this.clearFormControls(this.changePassFormGroup);
                },
                (error: ApplicationError) => {

                });
    }

    showSuccessMessage(message: string) : void {
        let connectDialog = new ConnectDialog();
        connectDialog.message = message;
        connectDialog.dialogType = 'SUCCESS';
        connectDialog.showCancelBtn = false;
        this.confirmDialogService.confirmDialog(connectDialog).subscribe();
    }

    clearPassword() : void {
        setTimeout(()=> {
            this.clearFormControls(this.changePassFormGroup);
        },1000);
    }

    clearFormControls(forGroup: FormGroup) : void {
        for (let field in forGroup.controls) {
            let formControl = forGroup.get(field);
            formControl.reset();
            formControl.setErrors(null);
        }
    }

}